// import React, { useState, useEffect, useContext, createContext } from "react";

// prettier-ignore
import { onAuthStateChanged, getAuth, initializeAuth, signInWithCredential, GoogleAuthProvider, signInWithPopup, OAuthProvider, indexedDBLocalPersistence, browserLocalPersistence, browserSessionPersistence, browserPopupRedirectResolver} from "firebase/auth";
// prettier-ignore
import { getFirestore,  getDoc,  doc, setDoc, serverTimestamp } from "firebase/firestore/lite";

// todo, investigate maybe loading getAuth etc only as needed
// https://github.com/firebase/firebase-js-sdk/issues/4946
// https://firebase.google.com/docs/auth/web/custom-dependencies

// Originally adapted from  https://usehooks.com/useAuth/

// can't seem to share it via expo_app/app_shared - with jsx
// https://github.com/vercel/next.js/issues/5666#issuecomment-817214225
// also symbolic link in expo_app/app_shared/ doesn't work
// https://stackoverflow.com/a/58829666/83859
// hence the non-jsx version below!

// only run this once XXX
export function setupGfbHook({
  React,
  useState,
  useEffect,
  useContext,
  createContext,
  firebase,
  db,
  isWebSite,
  do_native_apple_auth_signin, // optional, only for native ios
}) {
  const authContext = createContext();

  function ProvideAuth({ children }) {
    // renaming for v9 firebase upgrade, it encapsulates that
    const authHelperObj = useProvideAuth();
    // the below is the non jsx equivalent of: return <authContext.Provider value={authHelperObj}>{children}</authContext.Provider>;
    return /*#__PURE__*/ React.createElement(
      authContext.Provider,
      {
        value: authHelperObj,
      },
      children
    );
  }

  const auth = isWebSite
    ? initializeAuth(firebase, {
        persistence: [
          indexedDBLocalPersistence,
          browserLocalPersistence,
          browserSessionPersistence,
        ],
      })
    : getAuth(firebase);

  const useAuth = () => {
    return useContext(authContext);
  };

  function useProvideAuth() {
    const [user, setUser] = useState(null);
    // Wrap any Firebase methods we want to use making sure ...
    // ... to save the user to state.
    const signout = () => {
      // const auth = getAuth(firebase);
      return auth.signOut().then(() => {
        setUser(false);
      });
    };

    const signinAppleWeb = () => {
      const provider = new OAuthProvider("apple.com");
      provider.addScope("email");
      provider.addScope("name");
      // const auth = getAuth(firebase);

      return signInWithPopup(auth, provider, browserPopupRedirectResolver).then(
        async (response) => {
          // previously we did the maybe_create profile bit here
          return response.user;
        }
      );
    };

    const signinAppleIos = async () => {
      // const auth = getAuth(firebase);

      const nativeUser = await do_native_apple_auth_signin(auth);

      if (nativeUser) {
        // previously we did the maybe_create profile bit here
        //
        // return true to correctly display the success/fail login toaster
        return true;
      }
    };

    const signinGoogleIos = async (id_token) => {
      // const auth = getAuth(firebase);
      const credential = GoogleAuthProvider.credential(id_token);
      // console.log("credential::", credential);
      const response = await signInWithCredential(auth, credential);
      return response;
    };

    const signinGoogleWeb = () => {
      // const auth = getAuth(firebase);
      const provider = new GoogleAuthProvider();
      provider.addScope("https://www.googleapis.com/auth/userinfo.email");
      return signInWithPopup(auth, provider, browserPopupRedirectResolver).then(
        async (response) => {
          // previously we did the maybe_create profile bit here
          return response.user;
        }
      );
    };

    // Subscribe to user on mount
    // Because this sets state in the callback it will cause any ...
    // ... component that utilizes this hook to re-render with the ...
    // ... latest auth object.
    useEffect(() => {
      // const auth = getAuth(firebase);
      // console.log(auth);
      const unsubscribe = onAuthStateChanged(auth, async (user) => {
        if (user) {
          // we used to do this in most cases above in the signin cb
          await maybe_create_profile(firebase, user, isWebSite);
          setUser(user);
        } else {
          setUser(false);
        }
      });
      // Cleanup subscription on unmount
      return () => unsubscribe();
    }, []);
    // Return the user object and auth methods
    return {
      user,
      signinAppleWeb,
      signinAppleIos,
      signinGoogleIos,
      signinGoogleWeb,
      signout,
    };
  }
  return { ProvideAuth, useAuth };
}

// despite having a display name and photo url the profile is *not* the public_profile_page
// we get the name/photo info from the auth provider in some cases, so can use it to auto populate the actual public_profile_page
async function maybe_create_profile(
  firebase,
  { uid, email, fullName = {}, displayName = false, photoURL = false },
  isWebSite
) {
  const db = getFirestore(firebase);
  const docSnap = await getDoc(doc(db, "profiles", uid));
  // if it exists, return it!
  if (docSnap.exists()) {
    // console.log(docSnap.data());
    return docSnap.data();
  }
  console.log("creating...");
  // otherwise it's a new user, so set it up and then return it
  const created = serverTimestamp();

  fullName = get_clean_obj(fullName);
  // prettier-ignore
  const profile = { created, uid, email, fullName, services: {}, options: {}, displayName, photoURL };

  await setDoc(doc(db, "profiles", uid), profile);
  console.log("done creating");
  // hacky, but they put it into global scope so might as well
  // XXX fathom will not exist in the RN/expo app
  if (isWebSite && window.fathom && window.fathom.trackGoal) {
    try {
      window.fathom.trackGoal("BPLDQ6QT", 0);
    } catch (e) {}
  }
  return profile;
}

const get_clean_obj = (obj) => {
  return Object.entries(obj).reduce(
    (a, [k, v]) => (v == null ? a : ((a[k] = v), a)),
    {}
  );
};
